import { __awaiter } from "tslib";
import { useEffect, useState } from 'react';
import { useAemConfig } from '@as-react/common-components';
import ApplePayUtil from '../util/ApplePayUtil';
import BuyApi from '../api/buy/BuyAPI';
import { useIsClient } from '@as/cotopaxi';
import { isNullOrUndefined } from '@as-react/common-utils';
import { PaymentGroupName } from '@as-react/common-types';
const APPLE_PAY_SUPPORTED_NETWORKS_MAPPING = {
    MASTERCARD: 'masterCard',
    CARTESBANCAIRES: 'cartesBancaires',
    VPAY: 'vPay',
};
const APPLE_PAY_SUPPORTED_NETWORKS_FALLBACK = ['maestro', 'masterCard', 'visa'];
export const useApplePayButton = () => {
    const { defaultRequestParams, servicesEndpoint, applePayMerchantId } = useAemConfig();
    const [isApplePayCanMakePaymentsWithActiveCard, setIsApplePayCanMakePaymentsWithActiveCard] = useState(null);
    const [isApplePayChecked, setIsApplePayChecked] = useState(false);
    const [supportedNetworks, setSupportedNetworks] = useState([]);
    const isClient = useIsClient();
    const checkApplePayCanMakePaymentsWithActiveCard = () => __awaiter(void 0, void 0, void 0, function* () {
        const canMake = yield ApplePayUtil.canMakePaymentsWithActiveCard(applePayMerchantId);
        setIsApplePayCanMakePaymentsWithActiveCard(canMake);
    });
    const getPaymentOptions = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const paymentOptions = yield BuyApi.getPaymentOptions(servicesEndpoint, defaultRequestParams, PaymentGroupName.CREDITCARD.toLowerCase());
            const networks = paymentOptions
                .filter(option => option.enabled)
                .map(option => APPLE_PAY_SUPPORTED_NETWORKS_MAPPING[option.name] || option.name.toLowerCase());
            setSupportedNetworks(networks);
        }
        catch (_a) {
            setSupportedNetworks(APPLE_PAY_SUPPORTED_NETWORKS_FALLBACK);
        }
    });
    useEffect(() => {
        if (!ApplePayUtil.canMakePayments()) {
            setIsApplePayChecked(true);
            return;
        }
        if (!isNullOrUndefined(isApplePayCanMakePaymentsWithActiveCard)) {
            setIsApplePayChecked(true);
        }
    }, [isApplePayCanMakePaymentsWithActiveCard]);
    useEffect(() => {
        getPaymentOptions();
        checkApplePayCanMakePaymentsWithActiveCard();
    }, []);
    return {
        isApplePayChecked,
        isApplePayCanMakePaymentsWithActiveCard,
        isApplePayAvailable: isClient &&
            ApplePayUtil.canMakePayments() &&
            isApplePayCanMakePaymentsWithActiveCard &&
            supportedNetworks.length > 0,
        applePaySupportedNetworks: supportedNetworks,
    };
};
